import { RectangleF } from "../../../domain/rectangle-f";
import { Subject } from "rxjs";

export class RectangleFViewModel {
  public measureTypes: Array<{ id: EMeasureType; displayName: string }>;
  public selectedMeasureType: EMeasureType;
  public measureSign = "%";
  public updated = new Subject<RectangleF>();

  private _lastUpdatedRectangleF: RectangleF;
  private _lastSelectedMeasureType: EMeasureType;
  public static fromRectangleFObject(
    source: RectangleF,
    showMeasureTypeSelection = true,
  ): RectangleFViewModel {
    return new RectangleFViewModel(
      source.x * 100,
      source.y * 100,
      source.height * 100,
      source.width * 100,
      showMeasureTypeSelection,
    );
  }

  constructor(
    public x: number,
    public y: number,
    public height: number,
    public width: number,
    public showMeasureTypeSelection = true,
  ) {
    this.measureTypes = [];
    this.measureTypes.push(
      { id: EMeasureType.percent, displayName: "%" },
      { id: EMeasureType.px3840x2160, displayName: "3840x2160px" },
      { id: EMeasureType.px1920x1080, displayName: "1920x1080px" },
      { id: EMeasureType.px1280x720, displayName: "1280x720px" },
      { id: EMeasureType.px720x576, displayName: "720x576px" },
      { id: EMeasureType.px720x480, displayName: "720x480px" },
    );
    this.selectedMeasureType = this.measureTypes[0].id;
    this._lastSelectedMeasureType = this.selectedMeasureType;

    this._lastUpdatedRectangleF = this.toRectangleF();
    if (this._lastUpdatedRectangleF.validateBorders() === false) {
      this._lastUpdatedRectangleF = RectangleF.DEFAULT;
      this.x = this._lastUpdatedRectangleF.x * 100;
      this.y = this._lastUpdatedRectangleF.y * 100;
      this.width = this._lastUpdatedRectangleF.width * 100;
      this.height = this._lastUpdatedRectangleF.height * 100;
    }

    console.log("rectangle-f.VM->constructor", this._lastUpdatedRectangleF);
    this.updated.subscribe((rectangleF) => {
      this._lastUpdatedRectangleF = rectangleF;
      console.log(
        "rectangle-f.VM->this.updated.subscribe",
        this._lastUpdatedRectangleF,
      );
    });
  }

  validateInput(e: KeyboardEvent) {
    if (e.key === '-' || /-/.test(e.key)) {
      e.preventDefault();
    }
  }

  validateOnPasteEvent(event: ClipboardEvent) {
    const text = event.clipboardData?.getData('text') ?? '';
    if (text.includes('-')) {
      event.preventDefault();
    }
  }

  getMeasureTypeDisplayName(measureType: EMeasureType): string {
    if (measureType === EMeasureType.percent) {
      //console.log('RectangleFViewModel->getMeasureTypeDisplayName-> user %');
      return "%";
    }
    return EMeasureType[measureType].toString();
  }

  inputFieldUpdatedEventHandler(fieldName: string, event: any) {
    let value;
    if (this.selectedMeasureType === EMeasureType.percent) {
      value = parseFloat(event.target.value);
    } else {
      value = parseInt(event.target.value);
    }

    if (value < 0) {
      value *= -1;
    }

    const valueBeforeChange = Math.round(this[fieldName]);
    this[fieldName] = value;
    const stateBeforeChanges = this.toRectangleF();
    console.log(
      "rectange-f->inputFieldUpdatedEventHandler->",
      fieldName,
      value,
      valueBeforeChange,
      stateBeforeChanges,
    );
    if (stateBeforeChanges.validateBorders() === false) {
      this[fieldName] = valueBeforeChange;
      event.target.value = valueBeforeChange;
      console.log('rectange-f->inputFieldUpdatedEventHandler-> not valid state');
    }

    this.updated.next(this.toRectangleF());
  }

  getMeasureTypeSign(): string {
    //console.log('RectangleFViewModel->getMeasureTypeSign', this.selectedMeasureType, this.getMeasureTypeDisplayName(this.selectedMeasureType).substring(0, 2));
    return this.getMeasureTypeDisplayName(
      parseInt(this.selectedMeasureType.toString()),
    ).substring(0, 2);
  }
  public setMeasureType(measureType: number) {
    this.selectedMeasureType = measureType;
    this.measureTypesChangedEventHandler();
  }
  measureTypesChangedEventHandler() {
    this.selectedMeasureType = parseInt(this.selectedMeasureType.toString());

    if (
      this._lastSelectedMeasureType !== EMeasureType.percent &&
      this.selectedMeasureType !== EMeasureType.percent
    ) {
      //doing nothing
      console.log(
        "rectangle-f.VM->measureTypesChangedEventHandler",
        this._lastUpdatedRectangleF,
      );
      const { width, height } =
        this._extractWidthAndHeightFromSelectedMeasureType(
          this.selectedMeasureType,
        );
      this.width = width * this._lastUpdatedRectangleF.width;
      this.height = height * this._lastUpdatedRectangleF.height;
      this.x = width * this._lastUpdatedRectangleF.x;
      this.y = height * this._lastUpdatedRectangleF.y;
    } else if (this._lastSelectedMeasureType === EMeasureType.percent) {
      const { width, height } =
        this._extractWidthAndHeightFromSelectedMeasureType(
          this.selectedMeasureType,
        );
      this.width = (width * this.width) / 100;
      this.height = (height * this.height) / 100;
      this.y = (height * this.y) / 100;
      this.x = (width * this.x) / 100;
    } else {
      const { width, height } =
        this._extractWidthAndHeightFromSelectedMeasureType(
          this._lastSelectedMeasureType,
        );
      this.width = (this.width / width) * 100;
      this.height = (this.height / height) * 100;
      this.x = (this.x / width) * 100;
      this.y = (this.y / height) * 100;
    }

    this._lastSelectedMeasureType = this.selectedMeasureType;

    this.updated.next(this.toRectangleF());
  }

  public toRectangleF(): RectangleF {
    let xPercent = 0;
    let yPercent = 0;
    let heightPercent = 1;
    let widthPercent = 1;
    if (this.selectedMeasureType === EMeasureType.percent) {
      xPercent = this.x / 100;
      yPercent = this.y / 100;
      widthPercent = this.width / 100;
      heightPercent = this.height / 100;
    } else {
      const { width, height } =
        this._extractWidthAndHeightFromSelectedMeasureType(
          this.selectedMeasureType,
        );
      widthPercent = this.width / width;
      heightPercent = this.height / height;
      yPercent = this.y / height;
      xPercent = this.x / width;
    }

    return new RectangleF(xPercent, yPercent, widthPercent, heightPercent);
  }
  private _extractWidthAndHeightFromSelectedMeasureType(
    measureType: EMeasureType,
  ): { width: number; height: number } {
    const displayName = this.getMeasureTypeDisplayName(measureType);
    const { groups } = displayName.match(/px(?<width>\d+)x(?<height>\d+)/);
    return { width: parseInt(groups.width), height: parseInt(groups.height) };
  }

  getFloatingTimeFormat() {
    if (this.selectedMeasureType !== EMeasureType.percent) {
      return "0.0-0";
    }
    return "";
  }
}

enum EMeasureType {
  percent,
  px1920x1080,
  px3840x2160,
  px1280x720,
  px720x576,
  px720x480,
}
